<template>
  <md-dialog @close="close" ref="dialog">
    <mu-card>
      <mu-card-text>
        <h3 class="title">Show Macronutrients percentage:</h3>
      <mu-col>
        <mu-row style="margin-bottom: 10px">
          <mu-col>
            <p class="bold">Based on food weight consumed</p>
            <p>Recommended if you’re basing your daily intake
              on numbers you see on food labelling.</p>
          </mu-col>
          <mu-col>
            <mu-radio v-model="unit" value="g" native-value="g"/>
          </mu-col>
        </mu-row>
        <mu-row>
          <mu-col>
            <p class="bold">Based on the nutrient’s density</p>
            <p>Recommended for advanced members who prefer
              to see calorie breakdown by nutritional density.</p>
          </mu-col>
          <mu-col>
            <mu-radio v-model="unit" value="kcal" native-value="kcal"/>
          </mu-col>
        </mu-row>
      </mu-col>
      </mu-card-text>
      <mu-card-actions align="right">
        <mu-flat-button
          :label="$t('message.cancelText')"
          @click.native="hide"
        ></mu-flat-button>
        <mu-flat-button
          @click.native="update"
          :label="$t('message.updateText')"
          primary
        ></mu-flat-button>
      </mu-card-actions>
    </mu-card>
  </md-dialog>
</template>

<script>
export default {
  name: "NutritionUnitDialog",
  props: {
    show: Boolean,
    initialUnit: Boolean
  },
  data() {
    return {
      unit: "g",
      unitUpdated: false
    }
  },
  mounted() {
    this.resetMutableUnit();
  },
  methods: {
    resetMutableUnit() {
      this.unit = this.initialUnit
    },
    update() {
      this.unitUpdated = true;
      this.$emit('nutritionUnitChanged', this.unit)
      this.hide();
    },
    hide() {
      this.$refs['dialog'].close();
      this.close();
    },
    close() {
      if (!this.unitUpdated) {
        this.resetMutableUnit();
      }
      this.unitUpdated = false;
    },
    open() {
      this.$refs['dialog'].open();
    }
  }
}
</script>

<style scoped>
 p.bold {
   font-weight: bold;
   line-height: 1.5rem;
 }
</style>



// WEBPACK FOOTER //
// NutritionUnitDialog.vue?116c58e0